import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const errorPage = () => import(/* webpackChunkName:'index' */'../views/404.vue') // 错误页面404
const nolimitPage = () => import(/* webpackChunkName:'index' */'../views/403.vue') // 错误页面404
// 登录
const Login = () => import(/* webpackChunkName: 'login' */ '@/views/login/index.vue')
// 首页
const home = () => import(/* webpackChunkName: 'index' */ '@/views/home/index.vue')
// 数据分析首页
const analysis = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/index.vue')
// 数据分析 - 数据看板
const dataBroad = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/dataBroad/index.vue')
const analysisOverview = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/dataBroad/overview/index.vue') // 数据看板 - 总体概览
const analysisContent = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/dataBroad/content/index.vue') // 数据看板 - 内容分析
const analysisComment = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/dataBroad/comment/index.vue') // 数据看板 - 评论分析
const analysisGuruImage = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/dataBroad/guruImage/index.vue') // 数据看板 - 达人画像
// 数据分析 - 竞品对比
const competCompare = () => import(/* webpackChunkName: 'analysis' */ '@/views/analysis/competCompare/index.vue')
// 数据管理 - 笔记数据
const contentHome = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/content/index.vue')
const contentList = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/content/list/index.vue')
const contentDetail = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/content/detail/index.vue')
const contentImport = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/content/batchImport/index.vue')
// 数据管理 - 小红书指数
const exponentialHome = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/exponential/index.vue')
const exponentialList = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/exponential/list/index.vue')
const exponentialDetail = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/exponential/detail/index.vue')
const exponentialImport = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/exponential/batchImport/index.vue')
// 数据管理 - 笔记数据ZQ
const noteZQHome = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/noteZQ/index.vue')
const noteZQList = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/noteZQ/list/index.vue')
const noteZQDetail = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/noteZQ/detail/index.vue')
const noteZQImport = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/noteZQ/batchImport/index.vue')
const noteMolonChatImport = () => import(/* webpackChunkName: 'dataManage' */ '@/views/dataManage/noteZQ/molonChatImport/index.vue')
// 后台管理 - 首页
const backManage = () => import(/* webpackChunkName: 'backManage' */ '@/views/backManage/index.vue')
// 后台管理 - 用户管理列表
const userManage = () => import(/* webpackChunkName: 'backManage' */ '@/views/backManage/userManage/list/index.vue')
// 后台管理 - 用户管理详情
const userManageDetail = () => import(/* webpackChunkName: 'backManage' */ '@/views/backManage/userManage/detail/index.vue')
// 后台管理 - 用户权限
const userPermission = () => import(/* webpackChunkName: 'backManage' */ '@/views/backManage/userPermission/list/index.vue')
// 后台管理 - 用户权限详情
const userPermissionDetail = () => import(/* webpackChunkName: 'backManage' */ '@/views/backManage/userPermission/detail/index.vue')
// 后台管理 - 接入外部链接
const iframe = () => import(/* webpackChunkName: 'backManage' */ '@/views/iframe/index.vue')
const manageTableIframe = () => import(/* webpackChunkName: 'backManage' */ '@/views/manageTableIframe/index.vue')

const routes = [
  {
    path: '/403',
    name: '403',
    component: nolimitPage,
    meta: {
      requireNoAuth: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: errorPage,
    meta: {
      requireNoAuth: true
    }
  },
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      requireNoAuth: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      childrenAuthId: [
        {
          authId: '01-01',
          path: '/dataBroad'
        },
        {
          authId: '01-02',
          path: '/analysis/competCompare'
        },
        {
          authId: '02-01',
          path: '/dataManage/list'
        },
        {
          authId: '02-02',
          path: '/exponentialHome'
        },
        {
          authId: '02-03',
          path: '/noteZQHome'
        },
        {
          authId: '04-01',
          path: '/iframe?iframeSrc=' + process.env.VUE_APP_IFRAME_MANAGE_URL
        },
        {
          authId: '04-02',
          path: '/manageTableIframe?iframeSrc=' + process.env.VUE_APP_IFRAME_MANAGE_Table_URL
        },
        {
          authId: '03-01',
          path: '/back/userManage'
        },
        {
          authId: '03-02',
          path: '/back/userPermission'
        }
      ]
    },
    children: [
      {
        path: '/iframe',
        name: 'iframe',
        component: iframe,
        meta: {
          authId: '04-01',
          isHasCommonLoginOut: true
        }
      },
      {
        path: '/manageTableIframe',
        name: 'manageTableIframe',
        component: manageTableIframe,
        meta: {
          authId: '04-02',
          isHasCommonLoginOut: true
        }
      },
      {
        path: '/analysis',
        name: 'analysis',
        component: analysis,
        redirect: {
          name: 'competCompare'
        },
        meta: {
          childrenAuthId: [
            {
              authId: '01-01',
              path: '/dataBroad'
            },
            {
              authId: '01-02',
              path: '/analysis/competCompare'
            }
          ]
        },
        children: [
          {
            path: '/dataBroad',
            name: 'dataBroad',
            component: dataBroad,
            redirect: {
              name: 'analysisOverview'
            },
            meta: {
              authId: '01-01',
              isHasCommonLoginOut: true
            },
            children: [
              {
                path: '/analysis/overview',
                name: 'analysisOverview',
                component: analysisOverview,
                meta: {
                  authId: '01-01',
                  isHasCommonLoginOut: true
                }
              }, {
                path: '/analysis/content',
                name: 'analysisContent',
                component: analysisContent,
                meta: {
                  authId: '01-01',
                  isHasCommonLoginOut: true
                }
              },
              {
                path: '/analysis/comment',
                name: 'analysisComment',
                component: analysisComment,
                meta: {
                  authId: '01-01',
                  isHasCommonLoginOut: true
                }
              }, {
                path: '/analysis/guruImage',
                name: 'analysisGuruImage',
                component: analysisGuruImage,
                meta: {
                  authId: '01-01',
                  isHasCommonLoginOut: true
                }
              }
            ]
          }, {
            path: '/analysis/competCompare',
            name: 'competCompare',
            component: competCompare,
            meta: {
              authId: '01-02'
            }
          }
        ]
      },
      {
        path: '/contentHome',
        name: 'contentHome',
        component: contentHome,
        redirect: {
          name: 'contentList'
        },
        meta: {
          authId: '02-01'
        },
        children: [
          {
            path: '/dataManage/list',
            name: 'contentList',
            component: contentList,
            meta: {
              authId: '02-01',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/detail',
            name: 'contentDetail',
            component: contentDetail,
            meta: {
              authId: '02-01',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/contentImport',
            name: 'contentImport',
            component: contentImport,
            meta: {
              authId: '02-01',
              isHasCommonLoginOut: true
            }
          }
        ]
      },
      {
        path: '/exponentialHome',
        name: 'exponentialHome',
        component: exponentialHome,
        redirect: {
          name: 'exponentialList'
        },
        meta: {
          authId: '02-02'
        },
        children: [
          {
            path: '/dataManage/exponentialList',
            name: 'exponentialList',
            component: exponentialList,
            meta: {
              authId: '02-02',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/exponentialDetail',
            name: 'exponentialDetail',
            component: exponentialDetail,
            meta: {
              authId: '02-02',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/exponentialImport',
            name: 'exponentialImport',
            component: exponentialImport,
            meta: {
              authId: '02-02',
              isHasCommonLoginOut: true
            }
          }
        ]
      },
      {
        path: '/noteZQHome',
        name: 'noteZQHome',
        component: noteZQHome,
        redirect: {
          name: 'noteZQList'
        },
        meta: {
          authId: '02-03'
        },
        children: [
          {
            path: '/dataManage/noteZQList',
            name: 'noteZQList',
            component: noteZQList,
            meta: {
              authId: '02-03',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/noteZQDetail',
            name: 'noteZQDetail',
            component: noteZQDetail,
            meta: {
              authId: '02-03',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/noteZQImport',
            name: 'noteZQImport',
            component: noteZQImport,
            meta: {
              authId: '02-03',
              isHasCommonLoginOut: true
            }
          },
          {
            path: '/dataManage/noteMolonChatImport',
            name: 'noteMolonChatImport',
            component: noteMolonChatImport,
            meta: {
              authId: '02-03',
              isHasCommonLoginOut: true
            }
          }
        ]
      },
      {
        path: '/backManage',
        name: 'backManage',
        component: backManage,
        redirect: {
          name: 'userManage'
        },
        meta: {
          childrenAuthId: [
            {
              authId: '03-01',
              path: '/back/userManage'
            },
            {
              authId: '03-02',
              path: '/back/userPermission'
            }
          ]
        },
        children: [
          {
            path: '/back/userManage',
            name: 'userManage',
            component: userManage,
            meta: {
              authId: '03-01'
            }
          },
          {
            path: '/userManage/detail',
            name: 'userManageDetail',
            component: userManageDetail,
            meta: {
              authId: '03-01'
            }
          },
          {
            path: '/back/userPermission',
            name: 'userPermission',
            component: userPermission,
            meta: {
              // keepAlive: true,
              authId: '03-02'
            }
          },
          {
            path: '/userPermission/detail',
            name: 'userPermissionDetail',
            component: userPermissionDetail,
            meta: {
              authId: '03-02'
            }
          }
        ]
      },
      {
        path: '/analysis404',
        name: 'analysis404',
        component: errorPage,
        meta: {
          requireNoAuth: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
